<template>
  <CardItem
      :show-content="isCurrent"
      :options="options"
      v-on="$listeners"
  >
    <TextQuestion class="text-left">
      <TextCollapsed :title="survey.comment.title || defaultMessages.title" />
    </TextQuestion>
    <div class="flex flex-grow">
      <a-textarea
          v-model="value"
          ref="commentTextarea"
          :placeholder="survey.comment.placeholder || defaultMessages.placeholder"
          :autoSize="{minRows: 4, maxRows: 12}"
          :max-length="1000"
          style="border-radius: 10px;"
      />
    </div>
    <template #button>
      <a-button
          type="primary"
          class="btn-action-primary"
          :style="[buttonBgColor, buttonTextColor]"
          @click="onSubmit"
      >
        {{
          survey.translations.comment.buttonSubmit.value || survey.translations.comment.buttonSubmit.defaultValue
        }}
      </a-button>
    </template>
  </CardItem>
</template>

<script>
import {mapGetters} from "vuex";
import themeMixin from "../../mixins/theme.mixin";
import CardItem from "../CardItem";
import TextCollapsed from "../TextCollapsed";
import TextQuestion from "../TextQuestion";
import {isCreatorMode, isMobile} from "../../helpers/fns";

export default {
  name: "QuestionComment",
  props: {
    isCurrent: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
  },
  components: {CardItem, TextCollapsed, TextQuestion},
  mixins: [themeMixin],
  watch: {
    isCurrent(newVal) {
      if (
          newVal &&
          !isMobile() &&
          !isCreatorMode
      ) {
        this.$nextTick(() => {
          this.$refs.commentTextarea?.focus();
        });
      }
    }
  },
  data() {
    return {
      value: '',
      defaultMessages: {
        title: 'Tell us what you think',
        placeholder: 'Your feedback here',
        btnLabel: 'Send',
      },
    }
  },
  computed: {
    ...mapGetters(["survey"]),
  },
  methods: {
    onSubmit() {
      this.$emit('next', {comment: this.value});
    }
  }
}
</script>

<style lang="less" scoped>
.comment {
  height: 388px;
  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.15);
  border: 1px solid #EFEFEF;
  border-radius: 10px;
  background-color: @v-color-base-light;

  &__wrapper {
    width: 100%;
    max-width: 350px;
  }

  & > textarea {
    height: 224px;
    line-height: 1;
    font-size: @v-font-size-base;
    padding: 12px 20px;
  }
}

@media @v-mobile-break-point {
  .comment {
    height: @v-card-height;

    &__wrapper {
      width: @v-card-width;
    }
  }
}
</style>
